/**
 * PATH: packages/ui/src/kanban/card-surface/performance/virtualizationPolicy.ts
 * FILE_ID: UI-KANBAN-CARDSURFACE-VIRTUALIZATION-001
 * PURPOSE: Decide whether a card projection should mount a virtual window.
 * WHY: Surface-specific flags may differ, but threshold and safety semantics stay one contract.
 * FLOW: requested surface + flag + item count → active virtual window boolean.
 * DEPENDENCIES: none.
 * RELATED: lane/useVirtualizedLaneCards.ts; P4 performance budgets.
 */
export type CardVirtualizationSurface = 'flat' | 'split'

export interface CardVirtualizationPolicyInput {
  surface: CardVirtualizationSurface
  requested: boolean
  enabled: boolean
  itemCount: number
  threshold: number
}

export function shouldVirtualizeCardSurface({
  requested,
  enabled,
  itemCount,
  threshold,
}: CardVirtualizationPolicyInput): boolean {
  return requested && enabled && itemCount >= threshold
}
